import * as types from "../actions/types";


const initialState = {
    errorReport: {
        list: null,
        item: null
    },
    organization: {
        list: null
    }
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_ERROR_REPORTS_COMPLETED:
            return Object.assign({}, state, {
                errorReport: {
                    list: action.payload
                }
            });
        case types.GET_ERROR_REPORT_COMPLETED:
            return Object.assign({}, state, {
                errorReport: {
                    item: action.payload
                }
            });
        case types.CLEAR_ERROR_REPORT:
            return Object.assign({}, state, {
                errorReport: {
                    item: null
                }
            });
        case types.GET_ORGANIZATIONS_COMPLETED:
            return Object.assign({}, state, {
                organization: {
                    list: action.payload
                }
            });

        default:
            return state;
    }
};
